import type { WhatsappMode } from '@/types/settings';

/**
 * Build a WhatsApp URL for the given phone number and message.
 * Supports 3 modes: 'api' (api.whatsapp.com), 'wa' (wa.me), 'web' (web.whatsapp.com)
 */
export function buildWhatsappUrl(
  phone: string,
  message: string,
  mode: WhatsappMode = 'api'
): string {
  const cleanPhone = phone.replace(/[^0-9+]/g, '').replace(/^\+/, '');
  const encodedMessage = encodeURIComponent(message);

  switch (mode) {
    case 'wa':
      return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
    case 'web':
      return `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMessage}`;
    case 'api':
    default:
      return `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMessage}`;
  }
}

/**
 * Build a raw WhatsApp URL (without message) for quick contact.
 */
export function buildWhatsappUrlRaw(phone: string, mode: WhatsappMode = 'api'): string {
  const cleanPhone = phone.replace(/[^0-9+]/g, '').replace(/^\+/, '');

  switch (mode) {
    case 'wa':
      return `https://wa.me/${cleanPhone}`;
    case 'web':
      return `https://web.whatsapp.com/send?phone=${cleanPhone}`;
    case 'api':
    default:
      return `https://api.whatsapp.com/send?phone=${cleanPhone}`;
  }
}
